import { Button } from "@mui/material";
import { BackPageButtonSearchParamName } from "components/buttons/BackPageButton/types";
import AutocompleteControl from "components/form/AutocompleteControl";
import TextFieldControl from "components/form/TextFieldControl";
import { GRADE_OPTIONS } from "constants/global";
import ROUTES from "constants/routes";
import typography from "constants/typography.constants";
import VALIDATION from "helpers/validation";
import AuthSettings from "pages/Candidate/view/components/AuthSettings";
import qs from "qs";
import React from "react";
import { UseFormReturn } from "react-hook-form";
import { Link, useParams } from "react-router-dom";
import { InfoInputs } from "../types";
import CandidateSearch from "./CandidateSearch";

type CandidateInfoProps = {
  form: UseFormReturn<InfoInputs>;
  isEditing: boolean;
};

const CandidateInfo: React.FC<CandidateInfoProps> = ({ form, isEditing }) => {
  const { id: trialId } = useParams();
  const { watch } = form;

  const candidate = watch("candidate");
  const { id: candidateId, workEmail: candidateWorkEmail } = candidate;

  return (
    <>
      <CandidateSearch isEditing={isEditing} />
      {trialId && candidateId && (
        <Button
          variant='text'
          component={Link}
          to={{
            pathname: `/${ROUTES.CANDIDATE}/view/${candidateId}`,
            search: qs.stringify({ [BackPageButtonSearchParamName.TRIAL_ID]: trialId }),
          }}
          sx={{ justifyContent: "flex-start", p: 0 }}>
          Открыть карточку кандидата
        </Button>
      )}
      <TextFieldControl
        name='candidate.fullName'
        label='ФИО'
        rules={{ required: true, ...VALIDATION.fullUserName }}
        disabled
      />
      <TextFieldControl
        name='candidate.numericId'
        label='ID пользователя'
        rules={{ required: true, ...VALIDATION.inn }}
        disabled
      />
      <AuthSettings
        fieldsNamePrefix='candidate.'
        isEditing={false}
        companyCandidate={{ candidateUsername: candidate }}
        viewMode
      />
      <TextFieldControl
        name='candidate.workEmail'
        label='Рабочий Email'
        rules={VALIDATION.emailFull}
        labelLink={
          candidateWorkEmail
            ? { to: `mailto:${candidateWorkEmail}`, target: "_blank", text: typography.write }
            : undefined
        }
        disabled
      />
      <TextFieldControl
        name='candidate.phoneNumber'
        label='Номер телефона'
        disabled
        maskProps={{ mask: "+{7} (000) 000-00-00" }}
      />
      <TextFieldControl
        name='candidate.organization'
        label='Организация'
        rules={{ ...VALIDATION.companyName }}
        disabled
      />
      <TextFieldControl
        name='candidate.position'
        label='Должность'
        rules={{ ...VALIDATION.position }}
        disabled
      />
      <AutocompleteControl
        options={GRADE_OPTIONS}
        name='candidate.grade'
        label='Грейд кандидата'
        disabled
      />
    </>
  );
};

export default CandidateInfo;
